'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { SimilarProductsRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/SimilarProductsRecommendationsFragmentDoc';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { unmask } from '@packages/gql/src/betterMasking';
import { SimilarProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SimilarProductsRecoSlider/SimilarProductsRecoSlider.client';

/* GraphQL */ `
  fragment SimilarProductsRecommendations on Product {
    hasSeries
    promotion
    orderNumber
  }
`;

export type SimilarProductsRecommendationsProps = {
  /**
   * The data from the product query needed for the `SimilarProductsRecoSlider` comnponent.
   */
  data: FragmentType<typeof SimilarProductsRecommendationsFragmentDoc>;
};

/**
 * This component is a wrapper for the `SimilarProductsRecoSlider` component.
 * It encapsulates the data from the product query needed for the `SimilarProductsRecoSlider` component and passes correct props.
 */
export const SimilarProductsRecommendations = ({ data }: SimilarProductsRecommendationsProps) => {
  const { hasSeries, orderNumber, promotion } =
    unmask<typeof SimilarProductsRecommendationsFragmentDoc>(data);
  const { formatMessage } = useIntl();
  const {
    product: { hasTransparentSection },
  } = useConfig();

  return (
    <SimilarProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      elementIndex={hasSeries ? 3 : 2}
      fetchOnThreshold
      pageTemplate="detailview"
      title={formatMessage({
        id: 'rde.alternative-products.headline-fallback',
        defaultMessage: 'Ähnliche Artikel',
      })}
      key={`${orderNumber}3`}
      {...(hasTransparentSection && {
        backgroundColor: 'transparent',
      })}
    />
  );
};
